import { Component } from '@angular/core'
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular'

import { Meeting, Plan, Rate, SubscriptionPlan } from '../../models/models'
import { ApiProvider } from '../../providers/api/api'
import { SettingsProvider } from '../../providers/settings/settings'

@IonicPage()
@Component({
  selector: 'page-select-agreement',
  templateUrl: 'select-agreement.html'
})
export class SelectAgreementPage {
  agreement_type: string = 'card'
  plans: Plan[] = []
  pe_plans: Plan[] = []
  ADD_CARD_BASE_URL: string = 'https://admin.mypushop.com/contract-add-card/'
  CONTRACT_BASE_URL: string = 'https://admin.mypushop.com/accept/'
  EXPERIMENTAL_BASE_URL: string = 'https://admin.mypushop.com/accept-subscription/'
  baseUrl: string = ''
  meeting: Meeting
  isAlice = false

  RATE_FULL = 7
  RATE_STARTUP = 5

  depositAmounts: number[] = []
  rateNums: number[][] = []

  selectedRateNum: number
  selectedDepositAmount: number

  subscriptionPlans: SubscriptionPlan[] = []
  rates: Rate[] = []
  selectedSubscriptionPlan: SubscriptionPlan

  toastNoCommission: any

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private api: ApiProvider,
    private toastCtrl: ToastController,
    private readonly settings: SettingsProvider
  ) {
    if (typeof navParams.get('type') != 'undefined') {
      this.agreement_type = navParams.get('type')
    }

    if (this.agreement_type == 'card') {
      this.baseUrl = this.ADD_CARD_BASE_URL
    } else if (this.agreement_type == 'contract') {
      this.baseUrl = this.CONTRACT_BASE_URL
    }

    if (typeof navParams.get('meeting') != 'undefined') {
      this.meeting = navParams.get('meeting')
    }

    if (this.meeting?.deal?.product?.ac_label) {
      this.api.getSubscriptionPlansForProduct(this.meeting.deal.product.ac_label).subscribe(
        data => {
          this.subscriptionPlans = data
        },
        () => {
          this.notifyError()
        }
      )
    }
  }

  selectSubscriptionPlan(subscriptionPlan: SubscriptionPlan) {
    this.selectedDepositAmount = null
    this.selectedRateNum = null
    this.depositAmounts = []
    this.rateNums = []
    this.plans = []

    this.selectedSubscriptionPlan = subscriptionPlan
    this.api.getRates(subscriptionPlan.id).subscribe(
      data => {
        this.rates = data

        this.rates.forEach(rateDeposit => {
          let decimalDepositFee = this.convertToDecimal(rateDeposit.deposit_fee)
          this.depositAmounts.push(decimalDepositFee)
          this.rates.forEach(rateNum => {
            if (rateNum.deposit_fee == rateDeposit.deposit_fee) {
              if (this.rateNums[decimalDepositFee] === undefined) {
                this.rateNums[decimalDepositFee] = []
              }
              this.rateNums[decimalDepositFee].push(rateNum.number_total_rate)
            }
          })
        })

        this.depositAmounts = Array.from(new Set(this.depositAmounts))
        this.depositAmounts.sort((firstDeposit, secondDeposit) => {
          const difference = firstDeposit - secondDeposit
          if (difference < 0) {
            return -1
          }
          if (difference > 0) {
            return 1
          }
          return 0
        })

        this.rates.forEach(rate => {
          let label = rate.number_total_rate == 1 ? 'rata' : 'rate'
          this.plans.push({
            name: `${this.convertToDecimal(subscriptionPlan.entry_fee)} / ${rate.number_total_rate} ${label} + ${this.convertToDecimal(rate.deposit_fee)}`,
            rate_number: rate.number_total_rate,
            code: rate.queryparam,
            deposit: this.convertToDecimal(rate.deposit_fee),
            link: `${this.baseUrl}${rate.queryparam}/${this.meeting.deal.id}/`
          })
        })
      },
      () => {
        this.notifyError()
      }
    )
  }

  convertToDecimal(amount) {
    return amount / 100
  }

  selectDepositAmount(depositAmount: number) {
    this.selectedRateNum = null
    this.selectedDepositAmount = depositAmount
    this.rateNums[depositAmount] = Array.from(new Set(this.rateNums[depositAmount]))
    this.rateNums[depositAmount].sort((firstDeposit, secondDeposit) => {
      const difference = firstDeposit - secondDeposit
      if (difference < 0) {
        return -1
      }
      if (difference > 0) {
        return 1
      }
      return 0
    })

    if (this.toastNoCommission) {
      this.toastNoCommission.dismiss()
    }
    if (this.isDepositNotStandard(depositAmount)) {
      this.presentNoCommission()
    }
  }

  isDepositNotStandard(amount: number): boolean {
    return amount < 300 && this.meeting.deal.product.ac_label == this.settings.PRODUCT_MYP
  }

  goToAgreement(plan: Plan) {
    var win = window.open(plan.link, '_blank')
    win.focus()
    this.navCtrl.pop().then(() => this.navCtrl.pop())
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SelectAgreementPage')
  }

  filteredPlans(selectedDepositAmount?: number, selectedRateNum?: number): Plan[] {
    return this.plans.filter(plan => {
      if (selectedDepositAmount && plan.deposit !== selectedDepositAmount) {
        return false
      }
      if (selectedRateNum && plan.rate_number !== selectedRateNum) {
        return false
      }

      return true
    })
  }

  presentNoCommission() {
    this.toastNoCommission = this.toastCtrl.create({
      message: 'E\' stato scelto un contratto non standard. E\' necessaria l\'approvazione del direttore commerciale. Le tue provvigioni potrebbero subire delle variazioni.',
      position: 'top',
      showCloseButton: true,
      closeButtonText: 'Ok'
    })

    this.toastNoCommission.present()
  }

  notifyError(e: string = "") {
    this.toastCtrl.create({
      message: 'Si è verificato un errore ' + e,
      duration: 2000,
      position: 'top'
    }).present()
  }
}



// WEBPACK FOOTER //
// ./src/pages/select-agreement/select-agreement.ts